import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfigWebsitPouyan";

export const actionTypes = {
  getAllNews: "[getAllNews] Action",
  getAllNewsLoading: "[getAllNewsLoading] Action",
  getAllNewsAsync: "[getAllNewsAsync] Action",
};

const initialState = {
  data: [],
  size: 10,
  total: 10000,
  loading: false,
};

export const get_all_news_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.getAllNews:
      return {
        ...state,
        data: payload.results,
        total: payload.total ? payload.total : state.total,
      };
    case actionTypes.getAllNewsLoading:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};


function* handleWorker({ payload }) {
  let config = {
    url: `/News/GetAllNews?pageNumber=${payload?.pageNumber}&orderByFields=CreateDateTime%20desc%20'`,
    method: "GET"
  };


  let data = {
    ...payload?.data
  };

  yield put({
    type: actionTypes.getAllNewsLoading,
    payload: true,
  });

  try {
    let res = yield AxiosCustom(config, data);

    yield put({
      type: actionTypes.getAllNews,
      payload: {
        results: res?.data?.data?.news,
        total: res?.data?.data?.totalCount,
        size: res?.data?.data?.size,
      },
    });
    yield put({
      type: actionTypes.getAllNewsLoading,
      payload: false,
    });
  } catch {
    yield put({
      type: actionTypes.getAllNewsLoading,
      payload: false,
    });
  }
}

export function* get_all_news_worker() {
  yield takeLatest(actionTypes.getAllNewsAsync, handleWorker);
}
